import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { driver, driverType } from '../../types/slices/driverType'

const initialState: driverType =
{
    status: ApiStatus.FETCHED,
    drivers: [],
    totalRows: 0,
    driverSelected: {} as driver,
    errorMessage: undefined,
    action: ''
}

const driverSlice = createSlice({
    name: 'driverSlice',
    initialState,
    reducers: {
        onFetchDrivers (state, { payload }: { payload: driver[]}) {
            state.status = ApiStatus.FETCHED
            state.drivers = payload
            state.errorMessage = undefined
        },
        onFetchTotalRows (state, { payload }: { payload: number }) {
            state.totalRows = payload
        },
        onSetSelectedDriver (state, { payload }: { payload: driver }) {
            state.driverSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        }
    }
})

export const selectDriverState = (state: RootState) => state.driverSlice
export default driverSlice.reducer
export const {
    onFetchDrivers,
    onSetSelectedDriver,
    changeStatus,
    onFetchTotalRows,
} = driverSlice.actions
